import React, { useMemo } from "react";
import { ElementViewProps, MapSettings } from "@/shared/types";

const apiKey = "AIzaSyAN4FpvoTeToxAafc_OGlufckos2clD7_k";
const getUrl = (latitude: number, longitude: number, zoom: number) => {
  return `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${latitude},${longitude}&zoom=${zoom}`;
};

export interface MapViewProps extends ElementViewProps {}

const MapView: React.FC<MapViewProps> = ({ element }) => {
  const mapSettings = element?.settings as MapSettings;
  const location = {
    lat: mapSettings?.location?.lat!,
    lng: mapSettings?.location?.lng!,
  };
  const memoizedValue = useMemo(
    () => getUrl(location.lat, location.lng, mapSettings?.zoom!),
    [location.lat, location.lng, mapSettings?.zoom]
  );

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
      }}
    >
      <iframe
        title="Map-Element"
        style={{
          width: "100%",
          height: "100%",
          border: "0",
          borderStartStartRadius: mapSettings?.borderRadius?.startStart,
          borderStartEndRadius: mapSettings?.borderRadius?.startEnd,
          borderEndStartRadius: mapSettings?.borderRadius?.endStart,
          borderEndEndRadius: mapSettings?.borderRadius?.endEnd,
        }}
        src={memoizedValue}
      />
    </div>
  );
};

export { MapView };
